import axios from 'axios';

const CJC_ACCOUNT_ID = 5;

// Create dedicated axios instance for CJC functionality
const cjcAxios = axios.create({
  baseURL: process.env.REACT_APP_CJC_API_URL || 'http://api.pigeonconnect.charmedcoder.com/api/',
  headers: {
    Authorization: `Bearer ${CJC_ACCOUNT_ID}`
  }
});

// CJC-specific interceptors
cjcAxios.interceptors.request.use(
  (config) => {
    // If no authorization header is set or it's the default Bearer, use account Bearer token
    // If a Token authorization is already set (for authenticated requests), preserve it
    if (!config.headers.Authorization || config.headers.Authorization === `Bearer ${CJC_ACCOUNT_ID}`) {
      config.headers.Authorization = `Bearer ${CJC_ACCOUNT_ID}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

cjcAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle CJC-specific errors here if needed
    return Promise.reject(error);
  }
);

export default cjcAxios;